<!--
 Блок в виде предупреждения с иконкой восклицательного знака,
 используется в upsale и на финальной странице
-->
<template>
  <div class="alert-bar">
    <nuxt-icon
      :name="iconName"
      filled
      class="alert-bar__icon"
    />
    <slot />
    <base-button v-if="button" />
  </div>
</template>

<script setup lang="ts">
defineProps({
  iconName: {
    type: String,
    required: true,
  },
  button: {
    type: Boolean,
  },
});
</script>

<style lang="scss">
.alert-bar {
  display: flex;
  align-items: center;

  gap: 12px;

  border-radius: 9px;
  background: $neutral;

  padding: 16px;

  &__icon {
    flex-shrink: 0;
  }
}
</style>
